import { IFormSchema } from "../interfaces/IFormSchema";
import IObservation from "../interfaces/IObservation";
import _uniq from "lodash/uniq";
import { IPerson } from "../../sg-hpr/models/IPerson";
import { observationToPersonIds } from "./data.helpers";


export interface TIdentifiersDTO {
    henkilot: string;
    kohteet: string;
    lomakkeet: string;
};


export interface TIdentifiers {
    henkilot: Array<IPerson["id"]>;
    kohteet: Array<string>;
    lomakkeet: Array<string>;
};


export const extractObservationIdentifiers = (formData: IObservation["formData"], schema: IFormSchema): TIdentifiers => {
    const identifiers: TIdentifiers = {
        henkilot: [],
        kohteet: [],
        lomakkeet: []
    };

    let personIds = observationToPersonIds(formData, schema)
    identifiers.henkilot = personIds;


    const markings = formData.merkinnat;
    if (markings?.length) {
        let markingPersons: typeof personIds = [];
        markings.forEach((marking) => {
            if (marking.creator) {
                markingPersons = [...markingPersons, marking.creator]
            };
            if (marking.formData.vastaanottaja) {
                markingPersons = [...markingPersons, marking.formData.vastaanottaja]
            };
        });
        identifiers.henkilot = _uniq([...identifiers.henkilot, ...markingPersons]);
    };



    if (formData.kohde || formData.sijainti) {
        identifiers.kohteet = [(formData.kohde || formData.sijainti) as any];
    };

    return identifiers
};

export const extractObservationIdentifiersDTO = (formData: IObservation["formData"], formSchema: IFormSchema): TIdentifiersDTO | string => {
    const identifiers = extractObservationIdentifiers(formData, formSchema);

    if ((identifiers.henkilot.length + identifiers.kohteet.length + identifiers.lomakkeet.length) === 0) {
        return "n/a"
    };

    return {
        henkilot: identifiers.henkilot.join(","),
        kohteet: identifiers.kohteet.join(","),
        lomakkeet: identifiers.lomakkeet.join(","),
    }
}

